import { createAction, createReducer } from "@reduxjs/toolkit";

export interface FeatureFlagState {
  manualUploadDatasetDialog?: boolean;
  almanac?: boolean;
  allowThinkingExpansion?: boolean;
  showEditChart?: boolean;
  showRexFileUpload?: boolean;
}

export const updateFeatureFlag = createAction<FeatureFlagState>("featureFlag/update");

const initialState = {} as FeatureFlagState;

export const featureFlagReducer = createReducer(initialState, (builder) => {
  builder.addCase(updateFeatureFlag, (_state, action) => {
    return action.payload;
  });
});
